import { Tooltip } from '@material-ui/core';
import { DataGrid, GridCellParams, GridColumns } from '@material-ui/data-grid';
import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { useAlteracaoNcmLote } from '../../hooks/useAlteracaoNcmLote';
import { RowTableNCMEmLote } from '../../types/context';
import { ContainerTableNcmLote } from './styles';

const renderTooltipCell = (params: GridCellParams) => {
  const value = String(params.value ?? '');
  const formatTooltipValue = (tooltipValue: string) => {
    const match = tooltipValue.match(/^\s*(\d+)\s*\|\s*(\d+)\s*-\s*(.+)\s*$/);

    if (!match) return tooltipValue;

    const [, codigo, numero, descricao] = match;

    return `Código: ${codigo}, Número: ${numero} - ${descricao}`;
  };
  const content = (
    <div
      style={{
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {value}
    </div>
  );

  if (!value) return content;

  return (
    <Tooltip
      title={
        <span style={{ fontSize: '0.75rem' }}>{formatTooltipValue(value)}</span>
      }
      placement="bottom"
    >
      {content}
    </Tooltip>
  );
};

export const TableNcmEmLote: React.FC = () => {
  const { loading, rows, handleCheckProduct } = useAlteracaoNcmLote();

  const columns: GridColumns = useMemo(() => {
    const hasSimilar = (rows as RowTableNCMEmLote[])?.some(
      (r) => r?.flg_similar === true,
    );

    const baseColumns: GridColumns = [
      {
        field: 'cod_loja',
        headerName: 'Loja',
        headerAlign: 'center',
        align: 'center',
        width: 150,
        sortable: false,
      },
      {
        field: 'cod_produto',
        headerName: 'Código',
        width: 180,
        sortable: false,
      },
      {
        field: 'des_produto',
        headerName: 'Descrição',
        width: 450,
        sortable: false,
        renderCell: renderTooltipCell,
      },
      {
        field: 'des_ncm',
        headerName: 'NCM Atual',
        width: 350,
        sortable: false,
        renderCell: renderTooltipCell,
      },
      {
        field: 'actions',
        headerName: 'Transferir?',
        headerAlign: 'center',
        align: 'center',
        width: 150,
        sortable: false,
        headerClassName: 'hideRightSeparator',
        renderCell: (row: any) => {
          return (
            <Form.Check
              style={{ cursor: 'pointer' }}
              checked={row.row.flg_transferir}
              onClick={() => {
                handleCheckProduct(row.row.uuid);
              }}
            />
          );
        },
      },
    ];

    if (!hasSimilar) return baseColumns;

    const similarColumn = {
      field: 'des_similar',
      headerName: 'Similar',
      width: 450,
      sortable: false,
      valueGetter: (params: any) => params?.row?.des_similar ?? '',
      renderCell: renderTooltipCell,
    };

    const idxDesNcm = baseColumns.findIndex((c) => c.field === 'des_ncm');
    const insertAt = idxDesNcm >= 0 ? idxDesNcm : baseColumns.length;

    return [
      ...baseColumns.slice(0, insertAt),
      similarColumn,
      ...baseColumns.slice(insertAt),
    ];
  }, [handleCheckProduct, rows]);

  return (
    <ContainerTableNcmLote>
      <DataGrid
        className="table"
        loading={loading.table}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.uuid}
        hideFooter
        hideFooterRowCount
        hideFooterPagination
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar colunas',
        }}
      />
    </ContainerTableNcmLote>
  );
};
